module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-6.6cf02604.jpg";